import { render, staticRenderFns } from "./CommunicationPage.vue?vue&type=template&id=5cd303cd&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5cd303cd')) {
      api.createRecord('5cd303cd', component.options)
    } else {
      api.reload('5cd303cd', component.options)
    }
    module.hot.accept("./CommunicationPage.vue?vue&type=template&id=5cd303cd&", function () {
      api.rerender('5cd303cd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/communications/CommunicationPage.vue"
export default component.exports